module.exports = __webpack_public_path__ + "static/media/ic_en.bb8530a2.svg";